<div class="flex flex-wrap gap-6">
  @for(file of fileListItems; let i = $index; track file){
  <div class="image-div-container" (mouseenter)="hoveredFile = file" (mouseleave)="hoveredFile = null" (click)="viewModal(file, $event)">
    <div class="files-list relative hover:border-[#25508E]">
      @if(file.selected){
      <div
        style="border-radius: 10px"
        class="absolute top-[2px] left-[1px] z-[1] bg-[#5475C033] width-[232px] h-[295px] min-w-[232px] flex justify-center items-center"
      ></div>
      } @if(!hideCheckbox){
      <div class="absolute flex gap-1 items-center h-6 z-[1] top-3 cursor-pointer">
        <mat-checkbox
          type="checkbox"
          class="checkbox-input"
          [(ngModel)]="file.selected"
          (change)="onValueChange($event, file, i)"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
      </div>
      }
      <div class="absolute right-3 flex gap-1 items-center h-6 z-[1] top-3 cursor-pointer" *ngIf="file?.updated_at">
        <span class="setup-tag-container text-sm h-[27px]" [matTooltip]="file?.updated_at | date">
          <span class="text-sm">
            {{ file?.updated_at | date }}
          </span>
        </span>
      </div>

      <div class="donwlaod-continer">
        <div style="display: flex; flex-direction: column">
          <file-extension-preview
            style="width: 100%; background-color: #e3e3e3; border-radius: 8px 8px 0px 0px; cursor: pointer; text-align: center"
            [IconName]="file | materialIconName : 2"
            [link]="file?.link"
            [is_large_icon]="true"
            [link_available]="true"
            [index]="i"
            #fileExtensionComponentchild
            [file]="file"
            [formFileExtension]="true"
            [isActive]="file?.isActive"
          >
          </file-extension-preview>
        </div>

        <div
          class="mobile-divdownload-cross"
          style="height: 56px; display: flex; justify-content: space-between; border-top: 1px solid rgba(211, 220, 232, 0.7); padding: 12px"
        >
          <div class="flex flex-col">
            <p
              class="text-[13px] font-bold text-[#010B18] m-0"
              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 25px"
              [matTooltip]="file?.share_status === 'future' ? '' : file?.form_name"
              [ngClass]="{ 'blur-sm': file?.share_status === 'future' }"
            >
              {{ file?.form_name | truncateStrPipe : 20 }}
            </p>
            <p class="text-[#898F9E] font-medium text-[10px] m-0">{{ file?.type }}</p>
          </div>
          <div class="popup-menu" (click)="$event.stopPropagation()">
            <button
              mat-icon-button
              #menuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="menuItem"
              [disableRipple]="true"
              class="text-[#25508E]"
              style="height: 100%; padding: 0px"
            >
              <div class="see-more-btn font-bold text-[13px]"><span class="material-icons horiz">more_vert</span></div>
            </button>

            <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
              <button mat-menu-item class="popup-menu-item" (click)="viewModal(file, $event)">
                <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">visibility</span>View</p>
              </button>
              <button mat-menu-item class="popup-menu-item" (click)="downloadFile(file)">
                <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">download</span>Download</p>
              </button>
              <button mat-menu-item class="popup-menu-item" (click)="openShareModal(file)">
                <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">share</span>Share</p>
              </button>

              <button mat-menu-item class="popup-menu-item" (click)="duplicateTemplate(file)">
                <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">content_copy</span>Duplicate Template</p>
              </button>

              <button mat-menu-item class="popup-menu-item" (click)="moveAssetSingleItem(file, file?.id)">
                <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">low_priority</span>Move to</p>
              </button>

              <button mat-menu-item class="popup-menu-item" (click)="openActivityLogModel(file)">
                <p class="menuitem-text"><img style="margin: 0 12px 0 0px" src="assets/images/activity-log.svg" /> Activity Log</p>
              </button>

              <button mat-menu-item class="popup-menu-item" (click)="deleteFileFunction(file)">
                <p class="menuitem-text" style="color: red !important">
                  <img width="14px" src="assets/images/trash-2.svg" style="margin-right: 12px" />Delete Template
                </p>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
